import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Icon, Popup, Menu } from "semantic-ui-react";
import { selectDocument } from "../../actions/tasklist";
import FileMenuItem from "./FileMenuItem";

/**
 * OpenDocumentAction : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Context bar action that allows user to open and browse
 * through documents in the current context
 */
class OpenDocumentAction extends Component {
  state = {
    /**
     * isOpen: Boolean
     * True if the 'open document' popup is currently visible
     */
    isOpen: false
  };

  /**
   * handlePopupVisibilityChange = open => ()
   * Updates the state according to popup visibility,
   * can also be used to open / close the popup programmatically
   */
  handlePopupVisibilityChange = open => {
    this.setState({
      isOpen: open
    });
  };

  /**
   * openInOrganizer = () => ()
   * Opens the current context in the Organizer
   */
  openInOrganizer = () => {
    this.props.history.push("/organizer");
    this.handlePopupVisibilityChange(false);
  };

  /**
   * handleItemClick = (event, sender) => ()
   * Fired when a document in the popover is selected for opening
   */
  handleItemClick = (e, { name }) => {
    this.props.selectDocument(name, this.props.currentContext);
    this.props.history.push("/document");
    this.handlePopupVisibilityChange(false);
  };

  /**
   * render = () => ()
   * Renders the component conditionally if a current context is set
   * and loaded.
   */
  render() {
    if (!this.props.currentContext) return null;
    if (!this.props.files.hasOwnProperty(this.props.currentContext))
      return null;

    const files = this.props.files[this.props.currentContext];

    return (
      <Popup
        style={{ boxShadow: "none", padding: "0", border: "none" }}
        basic
        trigger={
          <Button icon>
            <Icon name="folder open outline" />
          </Button>
        }
        content={
          <Menu vertical fluid className="ax-action-menu">
            {files.map(document => (
              <FileMenuItem
                key={document.id}
                document={document}
                onClick={this.handleItemClick}
                currentApplication={this.props.currentApplication}
                currentDocument={this.props.currentDocument}
              />
            ))}
            <Menu.Item name="open-organizer" onClick={this.openInOrganizer}>
              <Icon name="ellipsis horizontal" />
              <span>
                <FormattedMessage
                  id="system.tasklist.open.organizer"
                  description="Action menu item to open the Organizer"
                />
              </span>
            </Menu.Item>
          </Menu>
        }
        on="click"
        position="bottom center"
        open={this.state.isOpen}
        onOpen={() => this.handlePopupVisibilityChange(true)}
        onClose={() => this.handlePopupVisibilityChange(false)}
      />
    );
  }
}

OpenDocumentAction.propTypes = {
  /**
   * History object provided through withRouter
   * for navigation
   */
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  /**
   * currentContext: String
   * Context identifier for the currently selected context
   */
  currentContext: PropTypes.string,
  /**
   * files: Object
   * Contains lists of currently loaded files ordered by context
   */
  files: PropTypes.shape({}).isRequired,
  /**
   * Dispatchable action to select a document
   */
  selectDocument: PropTypes.func.isRequired,
  /**
   * currentDocument: String
   * Document identifier for the currently selected document
   */
  currentDocument: PropTypes.string,
  /**
   * currentApplication: String
   * Application URL of the currently open application
   */
  currentApplication: PropTypes.string.isRequired
};

OpenDocumentAction.defaultProps = {
  currentContext: null,
  currentDocument: null
};

export default connect(
  null,
  { selectDocument }
)(withRouter(OpenDocumentAction));



// WEBPACK FOOTER //
// ./src/components/contextbar/OpenDocumentAction.js